import { render, staticRenderFns } from "./AchievementReceived.vue?vue&type=template&id=6f86d9d0&scoped=true&"
import script from "./AchievementReceived.vue?vue&type=script&lang=js&"
export * from "./AchievementReceived.vue?vue&type=script&lang=js&"
import style0 from "./AchievementReceived.vue?vue&type=style&index=0&id=6f86d9d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f86d9d0",
  null
  
)

export default component.exports